// Shared "Unverified" marker for the Phase 3 sub-entity tabs (Capabilities/Quotas/Policies/
// Payment Rules/Data Samples/Scopes/Versions) — none of these seven have confirmed real
// production seed data the way Phase 2's Templates/Rules/Hooks do (see this package's
// DevelopmentHistoryLog.md). Their field/route shapes were verified directly against the live
// BizFirstPayrollV3 backend, same rigor as every other tab, but never exercised against a running
// backend with real rows — this pair of components makes that distinction visible in the UI
// itself rather than a scope note only developers will ever read. Applied consistently by
// AgentEditor.tsx via a `tier: 'confirmed' | 'unverified'` field on SUB_ENTITY_TABS, rather than
// each panel deciding for itself whether to render it.

/** Small dot rendered next to an "Unverified" tab's label in the tab strip. */
export function UnverifiedTabDot() {
  return <span className="aaa-tab-unverified-dot" title="Unverified — no confirmed production data yet" aria-label="Unverified" />;
}

/** In-panel banner shown at the top of every "Unverified" tab's content. */
export function UnverifiedBanner({ entityName }: { entityName: string }) {
  return (
    <div className="aaa-unverified-banner" role="note">
      <strong>Unverified.</strong> The {entityName} tab's field and route shapes were confirmed
      directly against the live backend source, but this entity has no confirmed real production
      data and this UI has not yet been exercised against a running backend. Double-check results
      before relying on them.
    </div>
  );
}
